import * as React from 'react';
import {Breakpoints, styled} from '@volkswagen-onehub/components-core';

export * from './prices';

export const StyledCampaignPriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.size.static350};
    padding: ${props => props.theme.size.dynamic0130};
    max-width: ${Breakpoints.b2560}px;
    margin: 0 ${props => props.theme.size.grid002};

    background: ${props => props.theme.colors.background.offer};
    border-radius: ${props => props.theme.size.static100};

    @media (min-width: ${Breakpoints.b1280}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const TextContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.size.static350};
`;

const StyledButtonLinkWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    align-content: end;
    gap: ${props => props.theme.size.static250};

    @media (max-width: ${Breakpoints.b560 - 1}px) {
        button,
        a {
            width: 100%;
            text-align: center;
        }
    }

    @media (min-width: ${Breakpoints.b560}px) {
        justify-content: unset;
        width: fit-content;
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        flex-direction: row;
        justify-content: flex-start;

        // no wrap on desktop
        flex-wrap: nowrap;
        white-space: nowrap;
        align-self: end;
    }
`;

// NOTE: temporary solution to make A/Button yellow - needs to be fixed in Core.
// Currently core supports button with empasis "offer" only for button, not link.
const StyledPrimaryButtonWrapper = styled.span`
    button,
    a {
        color: ${props => props.theme.colors.content.invertedOnSurface};
        background: ${props => props.theme.colors.accent.offer.default};
        border: none;

        :hover {
            color: ${props => props.theme.colors.content.inverted};
            background: ${props => props.theme.colors.accent.offer.hover};
        }

        :active,
        :focus:not(:focus-visible) {
            color: ${props => props.theme.colors.content.inverted};
            background: ${props => props.theme.colors.accent.offer.active};
        }

        :focus-visible {
            outline: 3px solid ${props => props.theme.colors.focus.accent};
            outline-offset: unset;
        }
    }

    @media (max-width: ${Breakpoints.b560 - 1}px) {
        width: 100%;
        text-align: center;
    }
`;

export interface CampaignPriceProps {
    readonly prices?: JSX.Element;
    readonly primaryButton: JSX.Element;
    readonly buttonLink: JSX.Element;
    readonly description?: JSX.Element;
}

export function CampaignPrice(props: CampaignPriceProps): JSX.Element {
    const {prices, primaryButton, buttonLink, description} = props;

    return (
        <StyledCampaignPriceWrapper>
            <TextContentWrapper>
                {prices}
                {description}
            </TextContentWrapper>
            <StyledButtonLinkWrapper>
                {buttonLink}
                <StyledPrimaryButtonWrapper>
                    {primaryButton}
                </StyledPrimaryButtonWrapper>
            </StyledButtonLinkWrapper>
        </StyledCampaignPriceWrapper>
    );
}
